import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,

  sendDefaultPii: false,

  integrations: [],

  beforeSend(event) {
    if (event.user) {
      delete event.user;
    }
    return event;
  },
});
